module.exports = __webpack_public_path__ + "img/Engie Pro_80X30.3612d7f9.png";